import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import VueSweetalert2 from 'vue-sweetalert2';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {deleteLogoutCookies} from '@/assets/scripts/utility.js';
import '@vuepic/vue-datepicker/dist/main.css';
import "vue3-easy-data-table/dist/style.css";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import './assets/custom.css'

const app = createApp(App);

// Set up VueSweetalert2 globally
app.use(VueSweetalert2);
app.use(VueCookies);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('v-select', vSelect)
// Set Swal globally
window.Swal =  app.config.globalProperties.$swal;

// Define Axios base URL based on environment
let baseUrl = "https://centralreport-admin.property-pistol.in/api/";
if (process.env.NODE_ENV === 'production') {
  baseUrl = "https://centralreport-admin.property-pistol.in/api/";
}

axios.defaults.baseURL = baseUrl;

axios.interceptors.request.use(function(config) {
  const isLoginRequest = config?.url === "/central_report/login";
  store.dispatch(isLoginRequest ? 'setLoading' : 'setFilterLoading', true);

  // Only attach token for certain API requests
  if (config.url.indexOf('login') < 0) {
    let token = app.config.globalProperties.$cookies.get('user-token');
    if (token) {
      config.headers.Authorization = `Token token=${token}`;
    } else {
      return Promise.reject('No token available');
    }
  }

  // config.headers['Content-Type'] = 'application/json';
  config.headers['Accept'] = 'application/json';
  config.headers['ngrok-skip-browser-warning'] = true;
  
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  store.dispatch('setFilterLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  store.dispatch('setFilterLoading', false);
  return response;
}, function(error) {
  store.dispatch('setLoading', false);
  store.dispatch('setFilterLoading', false);
  
  if (error.response && error.response.status === 401) {
    deleteLogoutCookies(); 
    app.config.globalProperties.$swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    }).then(() => {
      router.replace('/login');
    });
  } else {
    return Promise.reject(error);
  }
});

// Set up Axios as a global property
app.config.globalProperties.$axios = axios;

router.beforeEach((to, from, next) => {
  let token = app.config.globalProperties.$cookies.get('user-token')
  if(token && to.name === 'Login'){
    next({name: 'LeadsDashboard'});
  }else if(to.name !== 'Login' && !token){
    next({name: 'Login'});
  } else {
    // if(to.name === 'Login'){
    //   store.dispatch('setLayout', 'login');
    // }else{
    //    store.dispatch('setLayout', 'default');
    // }
    next();
  }
});


app.config.productionTip = false;
app.use(router).use(store).mount('#app');
